import React from 'react'
import FilterBar from '../../../UI/filterbar'

const ReviewsFilters = ({filters,setFilters}) => {

  const filtersConfig = { search:"search",reviewStatus:"status",date:"date",rating:"rating"}
  return (
 <FilterBar  filters={filters} setFilters={setFilters}  filtersConfig={filtersConfig} />
  )
}

export default ReviewsFilters   